import get from 'lodash/get';

import { apiService, permissionService } from 'shared/services';
import {
  SET_CURRENT_USER,
  SET_CURRENT_PERMISSION,
  UPDATE_TOKEN,
  UPDATE_GET_ALL_TOKEN_LOADING,
  LOGOUT,
} from './types';
import { errorHandle } from './error';
import Auth0Service from '../../shared/services/Auth0Service';
import { audiences } from '../../shared/constant/index';
import { store } from '../store';

const auth0Instance = Auth0Service.getInstance();

const { amonraApiService } = apiService.getInstance();

const setPermission = me => {
  const userPermissions = get(me, 'user_details.user_metadata.permissions', []);
  const companyPermissions = get(me, 'organization_details.modules', []);

  let userModules = {};
  let companyModules = {};
  const permissions = [];
  userPermissions.forEach(permission => {
    const data = permission.split(':');

    userModules = {
      ...userModules,
      [data[0]]: [],
    };
    permissions.push(data);
  });
  companyPermissions.forEach(company => {
    companyModules = {
      ...companyModules,
      [company.name]: company.view_all,
    };
  });

  permissions.forEach(permission => {
    userModules[permission[0]].push(permission[1]);
  });

  store.dispatch({
    type: SET_CURRENT_PERMISSION,
    payload: { userModules, companyModules },
  });
};

export const getMe = isInit => dispatch =>
  amonraApiService
    .get(`me`)
    .then(auth.onGetMeSuccess(isInit, dispatch))
    .catch(auth.onGetMeError);

const onGetMeSuccess = (isInit, dispatch) => response => {
  const me = response.data.payload;
  dispatch({ type: SET_CURRENT_USER, me });

  if (isInit) {
    auth.setPermission(me);

    const userAudiences = get(
      response,
      'data.payload.user_details.user_metadata.audiences',
      '',
    );

    if (userAudiences) {
      const audienceIdentifiers = userAudiences.map(x => x.identifier);
      auth.getAllToken(audienceIdentifiers);
    } else {
      store.dispatch(auth.updateGetAllTokenLoading(false));
    }
  }
};

const onGetMeError = () => error => {
  throw error;
};

export const changePassword = (data, callback, callbackError) => () => {
  amonraApiService
    .patch(`users/password`, data)
    .then(response => {
      if (response.status === 204) {
        callback();
      }
    })
    .catch(error => {
      if (error.response) {
        if (error.response.status === 401) {
          callbackError(1);
        } else {
          callbackError();
          errorHandle(error);
        }
      } else {
        callbackError();
        errorHandle(error);
      }
    });
};

const updateGetAllTokenLoading = loading => ({
  type: UPDATE_GET_ALL_TOKEN_LOADING,
  loading,
});

const setEachToken = (audience, apiName, token) => {
  store.dispatch({
    type: UPDATE_TOKEN,
    payload: { [audience]: token },
  });
  apiService.getInstance().setToken(apiName, token);
};

const setToken = (audience, accessToken) => {
  switch (audience) {
    case audiences.ALLBILLER:
      setEachToken(
        audiences.ALLBILLER,
        'allBillerApiService',
        accessToken[audiences.ALLBILLER],
      );
      break;
    case audiences.AUDIT:
      store.dispatch({
        type: UPDATE_TOKEN,
        payload: { [audiences.AUDIT]: accessToken },
      });
      break;
    case audiences.EMAS:
      setEachToken(
        audiences.EMAS,
        'aurumApiService',
        accessToken[audiences.EMAS],
      );
      break;
    case audiences.DELIVERY:
      setEachToken(
        audiences.DELIVERY,
        'deliveryApiService',
        accessToken[audiences.DELIVERY],
      );
      break;
    case audiences.ORGANIZATION:
      setEachToken(
        audiences.ORGANIZATION,
        'amonraApiService',
        accessToken[audiences.ORGANIZATION],
      );
      break;
    default:
      break;
  }
};

export const getAllToken = userAudiences => {
  userAudiences.forEach(async audience => {
    // TODO: refactor later using promises to listen to each successful call until all async operation completed
    let accessToken = '';
    try {
      accessToken = await auth0Instance.auth0Client.getTokenSilently({
        audience,
      });
    } catch {
      accessToken = await auth0Instance.auth0Client.getTokenWithPopup({
        audience,
      });
    }

    const token = {
      [audience]: accessToken,
    };

    setToken(audience, token);
  });

  store.dispatch(updateGetAllTokenLoading(false));
};

const setPersistToken = (userAudiences, accessToken) => {
  userAudiences.forEach(audience => {
    setToken(audience, accessToken);
  });

  store.dispatch(updateGetAllTokenLoading(false));
};

export const initGetAllToken = () => async dispatch => {
  const { persistAudiences, tokens } = permissionService.getPersistData();
  if (persistAudiences.length) {
    setPersistToken(persistAudiences, tokens);
  } else {
    let accessToken = '';

    try {
      accessToken = await auth0Instance.auth0Client.getTokenSilently({
        audience: audiences.ORGANIZATION,
      });
    } catch {
      accessToken = await auth0Instance.auth0Client.getTokenWithPopup({
        audience: audiences.ORGANIZATION,
      });
    }

    apiService.getInstance().setToken('amonraApiService', accessToken);
    getMe(true)(dispatch);
  }
};

export const auth0logout = () => dispatch => {
  dispatch({ type: LOGOUT });

  auth0Instance.auth0Client.logout({
    client_id: process.env.AUTH0_CLIENT_ID,
    returnTo: window.location.origin,
  });
};

const auth = {
  setPermission,
  getMe,
  onGetMeSuccess,
  onGetMeError,
  changePassword,
  updateGetAllTokenLoading,
  setEachToken,
  setToken,
  getAllToken,
  setPersistToken,
  initGetAllToken,
  auth0logout,
};

export default auth;
